module.exports = __webpack_public_path__ + "media/gotmarried.c6f8e01f.mp3";